import { createFileRoute, Outlet, useMatch } from "@tanstack/react-router";

export const Route = createFileRoute("/food-app")({
  component: FoodAppLayout,
});

function FoodAppLayout() {
  const isJournal = !!useMatch({ from: "/food-app/sessions/$session_id", shouldThrow: false });
  // A tasting lays out its own outline and canvas, each scrolling on its own.
  const isTasting = !!useMatch({ from: "/food-app/tastings/$tasting_id", shouldThrow: false });

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {isJournal || isTasting ? (
        <div className="flex-1 overflow-hidden min-h-0">
          <Outlet />
        </div>
      ) : (
        <div className="flex-1 overflow-auto">
          <div className="p-10 w-full h-full">
            <Outlet />
          </div>
        </div>
      )}
    </div>
  );
}
